import { combineReducers } from '@reduxjs/toolkit'

import { reducer as selectedDetail } from './selectedDetail'

export default combineReducers({ selectedDetail })
